import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-images',
  imports: [],
  templateUrl: './brand-images.component.html',
  styleUrl: './brand-images.component.css',
})
export class BrandImagesComponent {

}
